export default __webpack_public_path__ + "static/media/2.d3fd3490.png";